globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.LocalManagement = appCustomerSpace.Modals.LocalManagement || {};

appCustomerSpace.Modals.LocalManagement.OptimizationReportCriteria = (function(superClass) {

  utils.extend(OptimizationReportCriteria, superClass);

  function OptimizationReportCriteria() {
    return OptimizationReportCriteria.__super__.constructor.apply(this, arguments);
  }

  $.extend(OptimizationReportCriteria.prototype, {
    init: function() {
      var modal = this;

      modal.$html.on('submit', 'form.manage-criteria-feedback-form', function(){
        $(this).find('button i').attr("class", "icon-spinner2 spinner");

        $.ajax({
          url: $(this).attr('action'),
          method: $(this).attr('method'),
          data: $(this).serialize(),
          success: function(data){
            if(data.html.criteria) {
              var $feedbacks = $(data.html.criteria.feedbacks);
              appCustomerSpace.LimitlessPlugins.initPlugins($feedbacks);
              $feedbacks.find("[data-popup='popover']").popover();

              modal.$html.find('.criteria-feedbacks').html($feedbacks);

              $('.optimization-criteria-modal-opener').filter(function() {
                return $(this).data('criteria-key') == data.html.criteria.key
              }).replaceWith($(data.html.criteria.modal_opener));
            }
          },
          error: function(data){
            alert("Opération impossible.")
          }
        });

        return false;
      });

      return OptimizationReportCriteria.__super__.init.apply(this, arguments);
    },
    open: function(){
      this.$html.find("[data-popup='popover']").popover();
      return OptimizationReportCriteria.__super__.open.apply(this, arguments);
    },
    submitEvents: function() {}
  });

  return OptimizationReportCriteria;

})(appCustomerSpace.Modal);
